__turbopack_context__.v({
  "accentWord": "page-header-module__TK9L3a__accentWord",
  "actions": "page-header-module__TK9L3a__actions",
  "back": "page-header-module__TK9L3a__back",
  "eyebrow": "page-header-module__TK9L3a__eyebrow",
  "header": "page-header-module__TK9L3a__header",
  "headerNoBorder": "page-header-module__TK9L3a__headerNoBorder",
  "left": "page-header-module__TK9L3a__left",
  "subtitle": "page-header-module__TK9L3a__subtitle",
  "subtitleInline": "page-header-module__TK9L3a__subtitleInline",
  "title": "page-header-module__TK9L3a__title",
});
